"use client";

import { c as _c } from "react/compiler-runtime";
import { useCurrentDeviceContext } from "@grupa-pracuj/ui-library-sip";
import { Typography } from "@grupa-pracuj/ui-system";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import PrefetchOnIntentLink from "@/components/PrefetchOnIntentLink";
import { getResolvedArchiveSearchParams } from "@/utils";
import styles from "./TimelineItem.module.css";
const TimelineItem = t0 => {
  const $ = _c(27);
  const {
    year,
    months
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const {
    isMobile
  } = useCurrentDeviceContext();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = getResolvedArchiveSearchParams({
      year: searchParams.get("year"),
      month: searchParams.get("month"),
      pageNumber: searchParams.get("pageNumber")
    });
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    year: activeYear,
    month: activeMonth
  } = t1;
  const monthsListId = `months-list-${year}`;
  const yearToggleActionLabel = isOpen ? "ukryj" : "poka\u017C";
  const yearAriaLabel = isMobile ? `Rok ${year}, ${yearToggleActionLabel} miesiące` : undefined;
  let t2;
  if ($[2] !== isMobile) {
    t2 = () => {
      if (!isMobile) {
        return;
      }
      setIsOpen(_temp);
    };
    $[2] = isMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleYearClick = t2;
  const t3 = isMobile ? monthsListId : undefined;
  const t4 = isMobile ? isOpen : undefined;
  const t5 = isMobile ? 0 : -1;
  let t6;
  if ($[4] !== handleYearClick || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== year || $[9] !== yearAriaLabel) {
    t6 = <Typography onClick={handleYearClick} size="small" component="button" type="button" className={styles.yearButton} aria-label={yearAriaLabel} aria-controls={t3} aria-expanded={t4} tabIndex={t5}>{year}</Typography>;
    $[4] = handleYearClick;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = year;
    $[9] = yearAriaLabel;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = `${styles.monthsList} ${isOpen ? styles.monthsListOpen : ""}`;
  let t8;
  if ($[11] !== activeMonth || $[12] !== activeYear || $[13] !== months || $[14] !== year) {
    let t9;
    if ($[16] !== activeMonth || $[17] !== activeYear || $[18] !== year) {
      t9 = t10 => {
        const {
          id,
          name
        } = t10;
        const month = Number(id.split("-")[1]);
        const isActiveMonth = Number(activeYear) === year && Number(activeMonth) === month;
        return <li key={id} className={styles.monthItem}><PrefetchOnIntentLink className={styles.monthLink} href={`/?year=${year}&month=${month}&pageNumber=1`} ariaCurrent={isActiveMonth ? "page" : undefined}>{name}</PrefetchOnIntentLink></li>;
      };
      $[16] = activeMonth;
      $[17] = activeYear;
      $[18] = year;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    t8 = months.map(t9);
    $[11] = activeMonth;
    $[12] = activeYear;
    $[13] = months;
    $[14] = year;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[20] !== monthsListId || $[21] !== t7 || $[22] !== t8) {
    t9 = <ul id={monthsListId} className={t7}>{t8}</ul>;
    $[20] = monthsListId;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t6 || $[25] !== t9) {
    t10 = <li className={styles.yearItem}>{t6}{t9}</li>;
    $[24] = t6;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default TimelineItem;
function _temp(previous) {
  return !previous;
}